import React from "react";
import { Nav } from "../../../../layouts/navbar/nav";
import images from "../../../../constant/images";
import {
  PiFacebookLogoLight,
  PiGoogleLogo,
  PiTwitterLogo,
} from "react-icons/pi";
import Header from "../../../../layouts/header";

export const Championship = () => {
  return (
    <>
      <div className="flex flex-col gap-[2rem]  mb-[5rem]">
        {/* <div
          style={{
            backgroundImage: `url(${images.Industry})`,
            height: "60vh",
            backgroundPosition: "40%",
            backgroundRepeat: "no-repeat",
            marginBottom: "0/5rem",
            backgroundSize: "cover",
            position: "relative",
          }}
        >
          <div className="absolute inset-0 bg-black bg-opacity-25"></div>
          <div>
            <Nav />
          </div>
          <div className="h-[50%] flex items-center justify-center">
            <h1 className="text-center relative text-white text-6xl mt-[3.5rem] custom-font">
              Non classé
            </h1>
          </div>
          <svg
            className="absolute bottom-[-9%] left-0 "
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1440 320"
          >
            <path
              class="white"
              fill="#fff"
              fill-opacity="1"
              d="M0,224L60,213.3C120,203,240,181,360,186.7C480,192,600,224,720,245.3C840,267,960,277,1080,250.7C1200,224,1300,170,1380,140L1440,120L1440,320L1380,320C1300,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"
            ></path>
          </svg>
        </div> */}
        <Header image={images.Industry} title={"GTM GOLF BLOG"} />
      </div>

      <div className="px-4 sm:px-8 md:px-12 lg:px-[12rem] mb-8 sm:mb-12 md:mb-16 lg:mb-[8rem]">
        <div className="flex flex-col md:flex-row gap-3">
          {/* Left Column */}
          <div className="flex flex-col gap-2">
            <p className="flex flex-col px-3 py-1 items-center bg-[#45ac4d] text-white font-bold text-lg sm:text-xl">
              28 <span className="text-sm sm:text-base font-medium">Nov</span>
            </p>
            <div className="flex flex-col gap-2">
              <div className="px-3 py-4 text-3xl text-[#4c67a2] border-2">
                <PiFacebookLogoLight />
              </div>
              <div className="px-3 py-4 text-3xl text-[#00acee] border-2">
                <PiTwitterLogo />
              </div>
              <div className="px-3 py-4 text-3xl text-[#d77066] border-2">
                <PiGoogleLogo />
              </div>
            </div>
          </div>

          {/* Right Column */}
          <div className="flex flex-col gap-8">
            <p className="text-3xl sm:text-4xl md:text-5xl custom-font">
              Golf: FRMG and CPG sign an agreement to support the expansion of
              the «GolfSixes Leagues» championship in Morocco
            </p>
            <p className="text-[#7c7c7c] text-base sm:text-lg md:text-xl font-medium w-full">
              The Royal Moroccan Golf Federation (FRMG), chaired by SAR Le
              Prince Moulay Rachid, and the «Confederation of Professional Golf»
              (CPG) have just signed an agreement on the development of the
              GolfSixes Leagues championship in Morocco. Signed in the wake of
              an international conference organized from 25 to 27 April 2023 by
              the R&A in St Andrews, Scotland, it aims to support the expansion
              of the GolfSixes Leagues championship in Morocco.
              <br />
              <br />
              The FRMG and the CPG will work together to develop this
              championship in Morocco, supported by The R&A and the two European
              Ladies and Men rounds, and which aims to promote the culture of
              golf among young people. The goal of the championship is to allow
              teams under 18 to compete in a fun and motivating game format that
              develops team spirit and competition.
              <br />
              <br />
              “The Royal Moroccan Golf Federation and the Confederation of
              Professional Golf welcome this collaboration, which will promote
              the culture of golf among young people. This convention marks an
              important step in the new expansion strategy of GolfSixes Leagues
              in continental Europe and other territories including Morocco. We
              are convinced that this collaboration will be beneficial for all
              parties involved and for the development of golf in Morocco,” said
              Riad Laissaoui, President of the FRMG Young Athletes Training
              Commission.
              <br />
              <br />
              Phil Anderton, Chief Development Officer at The R&A said:
              “GolfSixes is a fun and accessible form of golf that has been
              hugely successful in the UK and Ireland and we are pleased that
              the pilot project in Europe attracted many young people last year.
              We want to build on this momentum by expanding its reach to new
              countries so that more young people have the opportunity to enjoy
              golf and its health benefits with family and friends. As such, we
              are delighted that the Royal Moroccan Golf Federation is deploying
              GolfSixes.”
              <br />
              <br />
              «The launch of GolfSixes in Morocco is a fantastic continuation of
              the successful activations that have already taken place across
              Europe», said Ian Randell, General Manager of the Confederation of
              Professional Golf [CPG]. “We are delighted to see him venture into
              the African continent and are confident that he will prove to be
              an excellent example of how this exciting initiative offers the
              perfect solution for young people to progress on the golf course
              in a fun and engaging while enjoying the social and competitive
              pleasure of playing as a team ».
              <br />
              <br />
              Alexandra Armas, executive director of the Ladies European Tour,
              said: “Other countries have demonstrated how the GolfSixes format
              allows women and girls to learn golf together in a fun and social
              environment, and how the competitive element helps maintain
              interest and participation. We believe that GolfSixes will have
              the same positive impact on the development of golf in Morocco and
              will bring more women and girls into the sport. We wish the
              project every success.”
            </p>
          </div>
        </div>
      </div>

      {/* <div className="flex flex-col ps-[7rem] mb-[8rem]">
        <h1 className="text-2xl  custom-font">Leave A Reply</h1>
        <p className="text-[#7c7c7c] text-[19px] font-[500] ">Vous devez <span className="text-[#45ac4d]">vous connecter</span> pour publier un commentaire.</p>
      </div> */}
    </>
  );
};
